import { createApi } from '@reduxjs/toolkit/query/react';
import { INVOICES_BASE_URL } from 'shared/api/api';
import { createBaseQuery } from 'shared/api/rtk-query';
import { CreateInvoiceWccSupplierDto, InvoiceWccDto, UpdateInvoiceWccSupplierDto, WccDto } from '@sr/dto';

export const invoiceWccApi = createApi({
  reducerPath: 'invoiceWcc',
  baseQuery: createBaseQuery(`${INVOICES_BASE_URL}/wcc`),
  endpoints: (builder) => ({
    getInvoicesSupplierWcc: builder.query<WccDto[], number>({
      query: (id) => ({
        url: `/supplier/${id}`,
        method: 'GET'
      }),
      providesTags: (result, error, query) => [{ type: 'invoiceWcc', id: query }]
    }),

    createInvoiceSupplierWcc: builder.mutation<InvoiceWccDto, CreateInvoiceWccSupplierDto>({
      query: (dto) => ({
        url: '/supplier',
        body: dto,
        method: 'POST'
      }),
      invalidatesTags: (result, error, query) => [{ type: 'invoiceWcc', id: query.wccNumber }]
    }),

    dropInvoiceSupplierWcc: builder.mutation<void, number>({
      query: (wccId: number) => ({
        url: `/supplier/${wccId}`,
        method: 'DELETE'
      }),
      invalidatesTags: (result, error, query) => [{ type: 'invoiceWcc', id: query }]
    }),

    updateInvoiceSupplierWcc: builder.mutation<WccDto, UpdateInvoiceWccSupplierDto>({
      query: (data: UpdateInvoiceWccSupplierDto) => ({
        url: `/supplier/${data.id}`,
        body: data,
        formData: true,
        method: 'PUT'
      }),
      invalidatesTags: (res, error, query) => [{ type: 'invoiceWcc', id: query.id }]
    })
  }),
  tagTypes: ['invoiceWcc']
});
